(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-product-card"] && !Shopify.designMode) return;
  try {
    
(function () {
  var force = window.location.search.indexOf('stickydemo=1') !== -1;

  // Event capture goes through the storefront loader's PostHog instance. If the
  // visitor has not consented to analytics the loader never boots and these
  // calls are dropped — same rule as every other storefront event.
  function track(name, el, extra) {
    try {
      if (!window.posthog || typeof window.posthog.capture !== 'function') return;
      var props = {
        hi_product: el.getAttribute('data-hi-product') || null,
        hi_available: el.getAttribute('data-hi-available') === 'true',
        hi_article: window.location.pathname
      };
      if (extra) for (var k in extra) props[k] = extra[k];
      window.posthog.capture(name, props);
    } catch (e) { /* never break the page */ }
  }
  function shown(el) { return el && window.getComputedStyle(el).display !== 'none'; }

  // --- sticky bar: reveal on scroll, impression once, clicks ---
  var bars = document.querySelectorAll('.article-sticky-bar');
  bars.forEach(function (bar) {
    bar.hidden = false;
    var threshold = (parseInt(bar.dataset.threshold, 10) || 35) / 100;
    var seen = false;
    var update = function () {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      var past = scrollable > 0 ? window.scrollY / scrollable : 0;
      var visible = force || past >= threshold;
      bar.classList.toggle('is-visible', visible);
      if (visible && !seen && shown(bar)) { seen = true; track('hi_bar_impression', bar); }
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
    bar.addEventListener('click', function (ev) {
      var t = ev.target.closest('a, button');
      if (!t) return;
      var kind = t.classList.contains('article-sticky-bar__button')
        ? (bar.getAttribute('data-hi-available') === 'true' ? 'add_to_cart' : 'notify_me')
        : 'product_link';
      track('hi_bar_click', bar, { hi_target: kind });
    }, true);
  });

  // --- mid-article card: impression when half in view (hidden cards never intersect), clicks ---
  var cards = document.querySelectorAll('.article-product-card');
  if (cards.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && shown(en.target.parentElement)) { track('hi_card_impression', en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.5 });
    cards.forEach(function (c) { io.observe(c); });
  }
  cards.forEach(function (card) {
    card.addEventListener('click', function (ev) {
      var t = ev.target.closest('a');
      if (!t) return;
      var kind = t.classList.contains('article-product-card__button')
        ? (card.getAttribute('data-hi-available') === 'true' ? 'view_product' : 'notify_me')
        : 'product_link';
      track('hi_card_click', card, { hi_target: kind });
    }, true);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
